<template>
	<div class="component-wrap">
		<template v-if="type == 'hot'">
			<div
				class="movie_list-item fx-column"
				v-for="(item, index) in data"
				:key="index"
				@click="$emit('detail', item.film_id)"
			>
				<div class="movie_item-poster">
					<van-image
						:src="item.pic"
						width="110"
						height="130"
						fit="fill"
						ref="poster"
						class="poster"
						lazy-load
					></van-image>
					<span v-if="item.grade" class="movie-rate">{{ item.grade }}</span>
				</div>
				<div>
					<span class="movie-name van-multi-ellipsis--l">{{ item.name }}</span>
				</div>
				<div style="margin-top: 2px">
					<!--  -->
					<van-button
						v-if="item.isBuy"
						:color="$config.style.primaryColor"
						size="small"
						class="btn-small"
						@click.stop="$emit('buy', item.film_id, item.name)"
						>购票</van-button
					>
					<van-button
						v-else
						:color="$config.style.blueColor"
						size="small"
						class="btn-small"
						@click.stop="$emit('buy', item.film_id, item.name)"
					>
						预售
					</van-button>
				</div>
			</div>
		</template>
		<template v-else-if="type == 'future'">
			<div
				class="movie_list-item fx-column"
				v-for="(item, index) in data"
				:key="index"
				@click="$emit('detail', item.film_id, item.name)"
			>
				<div class="movie_item-poster">
					<van-image
						:src="item.pic"
						width="110"
						height="130"
						fit="fill"
						ref="poster"
						class="poster"
						lazy-load
					></van-image>
					<span v-if="item.grade" class="movie-rate">{{ item.grade }}</span>
				</div>
				<div>
					<span class="movie-name van-multi-ellipsis--l">{{ item.name }}</span>
				</div>
				<div style="margin-top: 2px">
					<span class="fc-tips">{{
						$momentFormatter(item.publish_date, "M月D日")
					}}</span>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { getDateDiff } from "@/libs/date-utils";
export default {
	props: {
		list: Array,
		type: {
			type: String,
			default() {
				return "hot";
			},
		},
	},
	data() {
		return {
			data: [],
			calendarExp: {},
		};
	},
	created() {},
	computed: {
		playDateMap() {
			let playDateMap = new Map();
			for (let item of this.list) {
				if (!playDateMap.has(item.playdate)) {
					playDateMap.set(item.playdate, new Array(item));
				} else {
					playDateMap.get(item.playdate).push(item);
					playDateMap.set(item.playdate, playDateMap.get(item.playdate));
				}
			}
			return playDateMap;
		},
	},
	methods: {
		getDateDiff,
		resizeStyle() {
			this.$refs.movieDetail.forEach((item, index) => {
				let poster = this.$refs.poster[index];
				let posterWidth = poster.$el.getBoundingClientRect().width;
				item.style.marginLeft = `${posterWidth + 10}px`;
			});
		},
	},
	watch: {
		list: {
			handler(val) {
				if (val && val.length >= 0) {
					let list = Object.assign([], val);
					this.data = list;
				}
			},
		},
	},
	filters: {
		format(val) {
			return val ? val.replace(RegExp(",", "g"), "/") : "";
		},
	},
};
</script>

<style lang="scss" scoped>
.component-wrap {
	padding: 2px 8px;
	padding-left: 0;
	display: flex;
	flex-direction: row;
	.movie_list-item {
		margin: 8px 0;
		background-color: #fff;
		border-radius: 5px;
		&:not(:nth-last-child(1)) {
			margin-right: 8px;
		}
		.movie_item-poster {
			position: relative;
			.poster {
				border-radius: 6px;
				overflow: hidden;
			}
		}
		.movie_item-showmark {
			background-color: rgba(0, 0, 0, 0.8);
			font-size: 10px;
			color: #fff;
			position: absolute;
			top: 2px;
			left: 2px;
			border-radius: 3px;
			padding: 1px 3px;
			// transform: scale(0.9)
		}
		.movie_item-detail {
			margin-left: 8px;
			width: 0px;
			> * {
				@include txt-ellipsis();
				color: $content-color;
				// line-height: 2;
			}
		}
		.movie-name {
			color: #000;
			font-size: 12px;
		}
		.movie-rate {
			position: absolute;
			color: #fff;
			background: rgba(0, 0, 0, 0.7);
			bottom: 5px;
			left: 0px;
			display: inline-block;
			padding: 0 10px;
			font-size: 14px;
			// margin-left: 5px;
			// color: $type-warning-dark;
			// font-size: 16px;
			// font-weight: 900;
		}
		.btn-small {
			height: 12px !important;
			line-height: 1 !important;
			padding: 10px !important;
		}
	}
	.movie-week {
		font-size: 10px;
	}
	.movie-day {
		font-size: 14px;
	}
}

.van-multi-ellipsis--l {
	display: -webkit-box;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}
</style>
